define([
    "dojo/_base/declare",
    "MW/layout/TabContainer",
    "MW/layout/TabContainerLender"
], function (declare, TabContainer, TabContainerLender) {

    /**
     * Sub-class the TabContainer to temporarily lend out panels
     */
    return declare([TabContainer, TabContainerLender], {});
});
